import { setTrackingId } from "client/Misc/utils";
import {
	MouseEvent,
	PropsWithChildren,
	ReactElement,
	useCallback
} from "react";
import styles from "./InlineActionList.module.less";

export type InlineActionListProps = {
	trackingId?: string;
};

export const InlineActionList = (props: PropsWithChildren<InlineActionListProps>): ReactElement => {
	const {
		trackingId,
		children
	} = props;

	const preventBlur = useCallback(
		(e: MouseEvent): void => {
			e.preventDefault();
			e.stopPropagation();
		},
		[]
	);

	return (
		<div
			{...setTrackingId(trackingId)}
			onMouseDown={preventBlur}
			className={styles.root}
		>
			{children}
		</div>
	);
};
InlineActionList.displayName = "InlineActionList";

const InlineActionListDivider = (): ReactElement => {
	return <div className={styles.divider} />;
};
InlineActionListDivider.displayName = "InlineActionList.Divider";

InlineActionList.Divider = InlineActionListDivider;